<template>
    <img
        :src="dataLogo"
        alt="logo"
        :loading="lazy ? 'lazy' : null"
        :onerror='`this.src="${DEFAULT_STOCK_LOGO}"`'
        @click="$emit('click')"
    />
</template>

<script>

const DEFAULT_STOCK_LOGO = require('../assets/images/icons/ent_default_avatar.svg');

export default {
    props: {
        logo: String,
        lazy: Boolean
    },
    data() {
        const logo = this.$props.logo
            ? this.$props.logo
            : DEFAULT_STOCK_LOGO;

        return {
            DEFAULT_STOCK_LOGO,
            dataLogo: logo
        };
    },
};
</script>

<style lang="less" scoped>

</style>
